import { MASTERMULTITOTAL } from "../../constants/cinemaTypes";


const getOptionalCinemaId = (multiCinemaMode, currentCinemaId, currentClientCinemaId) => {
    if((multiCinemaMode === MASTERMULTITOTAL && currentCinemaId === currentClientCinemaId)) {
        return false
    } else {
        return currentCinemaId
    }
}

export default getOptionalCinemaId